module.exports = __webpack_public_path__ + "img/idcard_r3x.0321aac7.png";